const initialState = {
  // Step data
  selectedDate: (() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  })(),
  mealType: 'lunch',
  plateSize: 'full',
  numberOfPlates: 1,
  
  // Customer details
  name: '',
  phone: '',
  email: '',
  address: '',
  
  // Delivery location
  deliveryLocation: '',
  selectedDeliveryCoords: null,
  deliveryDistance: null,
  locationSuggestions: [],
  isSearchingLocation: false,
  
  // UI state
  currentStep: 1,
  showLocationModal: false,
  currentLocationLoading: false,
  
  // Errors
  errors: {
    date: '',
    meal: '',
    plate: '',
    name: '',
    phone: '',
    email: '',
    address: '',
    deliveryLocation: '',
    currentLocation: ''
  },
  
  // OTP verification (for future use)
  showOTPModal: false,
  isPhoneVerified: false,
  phoneVerificationToken: null
};

const orderFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ORDER_FORM_UPDATE_FIELD':
      return {
        ...state,
        [action.payload.field]: action.payload.value,
        errors: {
          ...state.errors,
          [action.payload.field]: '', // Clear error when field updates
          ...(action.payload.field === 'selectedDeliveryCoords' ? { deliveryLocation: '' } : {})
        }
      };
    
    case 'ORDER_FORM_SET_ERROR':
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error
        }
      };
    
    case 'ORDER_FORM_CLEAR_ERROR':
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: ''
        }
      };
    
    case 'ORDER_FORM_SET_DELIVERY_LOCATION':
      return {
        ...state,
        deliveryLocation: action.payload.location,
        selectedDeliveryCoords: action.payload.coords,
        errors: {
          ...state.errors,
          deliveryLocation: ''
        }
      };
    
    case 'ORDER_FORM_SET_DELIVERY_DISTANCE':
      return {
        ...state,
        deliveryDistance: action.payload.distance
      };
    
    case 'ORDER_FORM_SET_STEP':
      return {
        ...state,
        currentStep: action.payload.step
      };
    
    case 'ORDER_FORM_TOGGLE_MODAL':
      return {
        ...state,
        [action.payload.modalName]: action.payload.value
      };
    
    case 'ORDER_FORM_SET_LOADING':
      return {
        ...state,
        currentLocationLoading: action.payload
      };
    
    case 'ORDER_FORM_RESET':
      return initialState;
    
    case 'REVERSE_GEOCODE_RESPONSE': {
      const addr = action.payload.address || '';
      const isLatLngFallback = addr.startsWith('Lat:') && addr.includes('Lng:');
      return {
        ...state,
        deliveryLocation: isLatLngFallback ? state.deliveryLocation : addr,
        currentLocationLoading: false,
        errors: {
          ...state.errors,
          currentLocation: action.payload.success ? '' : action.payload.error,
          ...(action.payload.success ? { deliveryLocation: '' } : {})
        }
      };
    }
    
    case 'LOCATION_SEARCH_RESPONSE':
      return {
        ...state,
        locationSuggestions: action.payload.success ? action.payload.suggestions || [] : [],
        isSearchingLocation: false,
        errors: {
          ...state.errors,
          locationSearch: action.payload.success ? '' : action.payload.error
        }
      };
    
    default:
      return state;
  }
};

export default orderFormReducer;
